function getFocusableElements(e) {
	return Array.from(
		e.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
	var r = getFocusableElements(e),
		a = r[0],
		s = r[r.length - 1];
	removeTrapFocus(),
		(trapFocusHandlers.focusin = (t) => {
			(t.target === e || t.target === s || t.target === a) &&
				document.addEventListener("keydown", trapFocusHandlers.keydown);
		}),
		(trapFocusHandlers.focusout = function () {
			document.removeEventListener("keydown", trapFocusHandlers.keydown);
		}),
		(trapFocusHandlers.keydown = function (t) {
			"TAB" === t.code.toUpperCase() &&
				(t.target !== s ||
					t.shiftKey ||
					(t.preventDefault(), a.focus()),
				(t.target === e || t.target === a) &&
					t.shiftKey &&
					(t.preventDefault(), s.focus()));
		}),
		document.addEventListener("focusout", trapFocusHandlers.focusout),
		document.addEventListener("focusin", trapFocusHandlers.focusin),
		t.focus(),
		"INPUT" === t.tagName &&
			["search", "text", "email", "url"].includes(t.type) &&
			t.value &&
			t.setSelectionRange(0, t.value.length);
}
function removeTrapFocus(e = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin),
		document.removeEventListener("focusout", trapFocusHandlers.focusout),
		document.removeEventListener("keydown", trapFocusHandlers.keydown),
		e && e.focus();
}
function onKeyUpEscape(e) {
	if ("ESCAPE" !== e.code.toUpperCase()) return;
	let t = e.target.closest("details[open]");
	if (!t) return;
	let r = t.querySelector("summary");
	t.removeAttribute("open"), r.setAttribute("aria-expanded", !1), r.focus();
}
function debounce(e, t) {
	let r;
	return (...a) => {
		clearTimeout(r), (r = setTimeout(() => e.apply(this, a), t));
	};
}
function fetchConfig(e = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${e}`,
		},
	};
}
class CartRemoveButton extends HTMLElement {
	constructor() {
		super(),
			this.addEventListener("click", (e) => {
				e.preventDefault(),
					this.closest("cart-drawer-items").updateQuantity(
						this.dataset.index,
						0
					);
			});
	}
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartDrawerItems extends HTMLElement {
	constructor() {
		super(),
			(this.lineItemStatusElement = document.getElementById(
				"CartDrawer-LineItemStatus"
			));
		let e = debounce((e) => {
			this.onChange(e);
		}, 300);
		this.addEventListener("change", e.bind(this));
	}
	cartUpdateUnsubscriber = void 0;
	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe("cart-update", (e) => {
			"cart-items" !== e.source && this.onCartUpdate();
		});
	}
	disconnectedCallback() {
		this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
	}
	onChange(e) {
		this.updateQuantity(
			e.target.dataset.index,
			e.target.value,
			document.activeElement.getAttribute("name")
		);
	}
	onCartUpdate() {
		fetch(`${theme.routes.cart_url}?section_id=main-cart-items`)
			.then((e) => e.text())
			.then((e) => {
				let t = new DOMParser()
					.parseFromString(e, "text/html")
					.querySelector("cart-items");
				this.innerHTML = t.innerHTML;
			})
			.catch((e) => {
				console.error(e);
			});
	}
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".cart-link__count",
			},
		];
	}
	updateQuantity(e, t, r) {
		this.enableLoading(e);
		let a = JSON.stringify({
			line: e,
			quantity: t,
			sections: this.getSectionsToRender().map((e) => e.section),
			sections_url: window.location.pathname,
		});
		fetch(`${theme.routes.cart_change_url}`, { ...fetchConfig(), body: a })
			.then((e) => e.text())
			.then((t) => {
				let a = JSON.parse(t),
					s = document.getElementById(`Drawer-quantity-${e}`);
				if (
					(document.querySelectorAll(".drawer__cart-item"), a.errors)
				) {
					(s.value = s.getAttribute("value")),
						this.updateLiveRegions(e, a.errors);
					return;
				}
				this.classList.toggle("is-empty", 0 === a.item_count);
				let n = document.querySelector("cart-drawer"),
					i = document.getElementById("main-cart-footer");
				i && i.classList.toggle("is-empty", 0 === a.item_count),
					n && n.classList.toggle("is-empty", 0 === a.item_count),
					this.getSectionsToRender().forEach((e) => {
						(
							document
								.getElementById(e.id)
								.querySelector(e.selector) ||
							document.getElementById(e.id)
						).innerHTML = this.getSectionInnerHTML(
							a.sections[e.section],
							e.selector
						);
					}),
					this.updateLiveRegions(e, "");
				let o = document.getElementById(`CartDrawer-Item-${e}`);
				o && o.querySelector(`[name="${r}"]`)
					? n
						? trapFocus(n, o.querySelector(`[name="${r}"]`))
						: o.querySelector(`[name="${r}"]`).focus()
					: 0 === a.item_count && n
					? trapFocus(
							n.querySelector(".drawer__inner-empty"),
							n.querySelector("a")
					  )
					: document.querySelector(".drawer__cart-item") &&
					  n &&
					  trapFocus(n, document.querySelector(".cart-item__name")),
					publish("cart-update", { source: "cart-items" });
			})
			.catch((e) => {
				this.querySelectorAll(".loading-overlay").forEach((e) =>
					e.classList.add("hidden")
				),
					(document.getElementById(
						"CartDrawer-CartErrors"
					).textContent =
						"There was an error while updating your cart. Please try again.");
			})
			.finally(() => {
				this.disableLoading(e);
			});
	}
	updateLiveRegions(e, t) {
		let r = document.getElementById(`CartDrawer-LineItemError-${e}`);
		r && (r.querySelector(".cart-item__error-text").innerHTML = t),
			this.lineItemStatusElement.setAttribute("aria-hidden", !0);
		let a = document.getElementById("CartDrawer-LiveRegionText");
		a.setAttribute("aria-hidden", !1),
			setTimeout(() => {
				a.setAttribute("aria-hidden", !0);
			}, 1e3);
	}
	getSectionInnerHTML(e, t) {
		return new DOMParser().parseFromString(e, "text/html").querySelector(t)
			.innerHTML;
	}
	enableLoading(e) {
		document
			.getElementById("CartDrawer-CartItems")
			.classList.add("cart__items--disabled");
		let t = this.querySelectorAll(`#CartItem-${e} .loading-overlay`),
			r = this.querySelectorAll(`#CartDrawer-Item-${e} .loading-overlay`);
		[...t, ...r].forEach((e) => e.classList.remove("hidden")),
			document.activeElement.blur(),
			this.lineItemStatusElement.setAttribute("aria-hidden", !1);
	}
	disableLoading(e) {
		document
			.getElementById("CartDrawer-CartItems")
			.classList.remove("cart__items--disabled");
		let t = this.querySelectorAll(`#CartItem-${e} .loading-overlay`),
			r = this.querySelectorAll(`#CartDrawer-Item-${e} .loading-overlay`);
		t.forEach((e) => e.classList.add("hidden")),
			r.forEach((e) => e.classList.add("hidden"));
	}
}
customElements.define("cart-drawer-items", CartDrawerItems);
class QuantityInput extends HTMLElement {
	constructor() {
		super(),
			(this.input = this.querySelector("input")),
			(this.input.initValue = this.input.getAttribute("data-initial-value")),
			(this.changeEvent = new Event("change", { bubbles: !0 })),
			this.input.addEventListener(
				"change",
				this.onInputChange.bind(this)
			),
			this.querySelectorAll("button").forEach((e) =>
				e.addEventListener("click", this.onButtonClick.bind(this))
			);
	}
	quantityUpdateUnsubscriber = void 0;
	connectedCallback() {
		this.validateQtyRules(),
			(this.quantityUpdateUnsubscriber = subscribe(
				"quantity-update",
				this.validateQtyRules.bind(this)
			));
	}
	disconnectedCallback() {
		this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
	}
	onInputChange(e) {
		this.validateQtyRules();
	}
	onButtonClick(e) {
		e.preventDefault();
		let t = this.input.value;
		"plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
			t !== this.input.value &&
				this.input.dispatchEvent(this.changeEvent);
	}
	validateQtyRules() {
		let value = parseInt(this.input.value);
		const initValue = parseInt(this.input.initValue);
		const min = parseInt(this.input.min);

		this.querySelector(".quantity__button[name='minus']").classList.toggle("disabled", value <= min);

		if (initValue == value || value < min){
			this.input.value = initValue;
			value = initValue;
		}
		if (this.input.max) {
			const max = parseInt(this.input.max);
			this.querySelector(".quantity__button[name='plus']").classList.toggle("disabled", value >= max);
		}
	}
}
customElements.define("quantity-input", QuantityInput);
class CartDrawer extends HTMLElement {
	constructor() {
		super(),
			this.addEventListener(
				"keyup",
				(e) => "Escape" === e.code && this.close()
			),
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			),
			this.setHeaderCartIconAccessibility();
			this.openDrawerByURL();
	}
	setHeaderCartIconAccessibility() {
		let e = document.querySelector("#cart-icon-bubble");
		e.setAttribute("role", "button"),
			e.setAttribute("aria-haspopup", "dialog"),
			e.addEventListener("click", (t) => {
				t.preventDefault(), this.open(e);
			}),
			e.addEventListener("keydown", (t) => {
				"SPACE" === t.code.toUpperCase() &&
					(t.preventDefault(), this.open(e));
			});
	}
	open(e) {
		e && this.setActiveElement(e);
		let t = this.querySelector('[id^="Details-"] summary');
		t && !t.hasAttribute("role") && this.setSummaryAccessibility(t),
			setTimeout(() => {
				this.classList.add("active");
			}),
			this.addEventListener(
				"transitionend",
				() => {
					trapFocus(
						this.classList.contains("is-empty")
							? this.querySelector(".drawer__inner-empty")
							: document.getElementById("CartDrawer"),
						this.querySelector(".drawer__inner") ||
							this.querySelector(".drawer__close")
					);
				},
				{ once: !0 }
			),
			document.body.classList.add("overflow-hidden");
	}
	close() {
		this.classList.remove("active"),
			removeTrapFocus(this.activeElement),
			document.body.classList.remove("overflow-hidden");
	}
	setSummaryAccessibility(e) {
		e.setAttribute("role", "button"),
			e.setAttribute("aria-expanded", "false"),
			e.nextElementSibling.getAttribute("id") &&
				e.setAttribute("aria-controls", e.nextElementSibling.id),
			e.addEventListener("click", (e) => {
				e.currentTarget.setAttribute(
					"aria-expanded",
					!e.currentTarget.closest("details").hasAttribute("open")
				);
			}),
			e.parentElement.addEventListener("keyup", onKeyUpEscape);
	}
	renderContents(e, t = !0) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty"),
			(this.productId = e.id),
			this.getSectionsToRender().forEach((t) => {
				(t.selector
					? document.querySelector(t.selector)
					: document.getElementById(t.id)
				).innerHTML = this.getSectionInnerHTML(
					e.sections[t.id],
					t.selector
				);
			}),
			publish("cart-update", { source: "cart-items", cartData: e }),
			setTimeout(() => {
				this.querySelector("#CartDrawer-Overlay").addEventListener(
					"click",
					this.close.bind(this)
				),
					t && this.open();
			});
	}
	getSectionInnerHTML(e, t = ".shopify-section") {
		return new DOMParser().parseFromString(e, "text/html").querySelector(t)
			.innerHTML;
	}
	getSectionsToRender() {
		return [
			{ id: "cart-drawer", selector: "#CartDrawer" },
			{ id: "cart-icon-bubble", selector: ".cart-link__count" },
		];
	}
	getSectionDOM(e, t = ".shopify-section") {
		return new DOMParser().parseFromString(e, "text/html").querySelector(t);
	}
	setActiveElement(e) {
		this.activeElement = e;
	}
	openDrawerByURL() {
		const e = new URL(window.location.href).searchParams.get("viewcart");
		"true" === e && this.open();
	}

}
customElements.define("cart-drawer", CartDrawer);
class CartTextarea extends HTMLElement {
	constructor() {
		super();
		this.addEventListener(
			"change",
			debounce((event) => {
				const body = this.getData( event.target.value );
				fetch(`${theme.routes.cart_update_url}`, {
					...fetchConfig(),
					...{ body },
				});
			}, 300)
		);
		this.addEventListener('input', (event) => {
			this.querySelector('.form__input--count-curr').textContent = event.target.value.length
		});
	}
	getData( value ){
		return JSON.stringify({ note: value });
	}
}
if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends CartTextarea {
			constructor() {
				super();
			}
		}
	);
}

if (!customElements.get("cart-gift-note")) {
	customElements.define(
		"cart-gift-note",
		class CartGiftNote extends CartTextarea {
			constructor() {
				super();
			}
			getData( value ){
				return JSON.stringify({attributes: {"Gift Note": value}});
			}
		}
	);
}

document.addEventListener("DOMContentLoaded", function() {
	    const cartDrawerContainer = document.querySelector('cart-drawer');
	
	    function checkForhulkTotalText() {
			
				const hulkTotalTextDisplayed = cartDrawerContainer.querySelector('.discount_code_box .after_discount_price');

				const subtotalText = cartDrawerContainer.querySelector('.cart-drawer__footer .totals__total-value');
				
				const SubtotalEntireField = cartDrawerContainer.querySelector('.cart-drawer__footer');

				const removeDiscount = cartDrawerContainer.querySelector('.hulkapps-summary-line-discount-code .discount-tag .close-tag');
				
	        if (hulkTotalTextDisplayed) {	
				hulkTotalTextDisplayed.classList.add('hulk-custom-total-text')
				subtotalText.classList.add('hulk-custom-subtotal-text')
				SubtotalEntireField.appendChild(hulkTotalTextDisplayed);
				removeDiscount.addEventListener('click', function(){
					subtotalText.classList.remove('hulk-custom-subtotal-text')
				})

			} 
			
	    }
	
		
	    checkForhulkTotalText();
	
	    const observer = new MutationObserver(mutations => {
	        for (const mutation of mutations) {
	            if (mutation.type === 'childList') {
	                checkForhulkTotalText();
	            }
	        }
	    });
	    observer.observe(cartDrawerContainer, { childList: true, subtree: true });
	});